import component from './projectIntegration.vue'

export default component
